/// <reference path = "../../node_modules/@types/jquery/index.d.ts" />
/// <reference path = "../../node_modules/@types/jqueryui/index.d.ts" />

jQuery(document).ready(function(){
	// console.info('hello world');


	// For home image map background brightness effect
	var check_click = 0; 
	jQuery('.home_image_map_button').hover(function(){
    	jQuery(".main_image").addClass("hover", 300);
    }, function(){
			if(check_click == 0){
				jQuery(".main_image").removeClass("hover", 300);
			}
    }
  );

	// For the button click event to display popup box and FAQ listing
	jQuery( ".home_image_map_button" ).click(function() {
		var page_name = jQuery(this).data('page');
		
		if(page_name == "faq" ){
			jQuery(".elementor-accordion").addClass("show", 300);
			var n = jQuery(".section_home_image_map").height();
    	jQuery('html, body').animate({ scrollTop: n }, 300);
		} else {
			jQuery( ".home_image_map_button" ).removeClass("hover", 300);
			jQuery(".main_image").addClass("hover", 300);
			jQuery(this).addClass("hover", 300);
			jQuery(".section_popup_box").addClass("show", 300);
			jQuery("#"+page_name).addClass("show", 300);
			check_click = 1;
		}
	});

	// Close popup box
	jQuery( ".btn_close" ).click(function() {
		reset_page();
	});

	// Close popup box
	jQuery( ".section_popup_box" ).click(function() {
		reset_page();
	});

	// On hold close popup box when the user is click on the popup content box
	jQuery( ".section_popup_box_content" ).click(function() {
		event.stopPropagation();
	});

	// Reset the popup box
	function reset_page(){
		jQuery( ".main_image" ).removeClass("hover", 300);
		jQuery( ".home_image_map_button" ).removeClass("hover", 300);
		jQuery(".section_popup_box").removeClass("show", 300);
		jQuery(".section_popup_box_content").removeClass("show", 300);
		check_click = 0;
	}

});